'use client';

import { FC,useEffect, useRef} from 'react';
import SpriteIcon from '../shared/sprite-icon';
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import { OwCarousel } from '../../interfaces/domain/ow-carousel.modal';
import CarouselImageSliderItem from './carousel-image-slider-item';

// -----------------------------------------------------------------------------
interface Props {
  sliderData: OwCarousel;
}

// -----------------------------------------------------------------------------
export const CarouselImageSlider: FC<Props> = ({sliderData}): JSX.Element => {
  const {interval, slides} = sliderData;

  const carouselImageSlider = useRef<HTMLDivElement>(null);
  const navigationNext = useRef<HTMLButtonElement>(null);
  const navigationPrev = useRef<HTMLButtonElement>(null);
  const sliderPagination = useRef<HTMLDivElement>(null);

  const visibleSlides = slides?.filter(slide => !slide.hidden) ?? [];
  const hasMultipleSlides = visibleSlides.length > 1;

  useEffect(() => {
    const carouselSliderConfig = new Swiper(carouselImageSlider.current, {
      speed: 700,
      effect: 'fade',
      loop: hasMultipleSlides,
      fadeEffect: {
        crossFade: true
      },
      centeredSlides: false,
      autoplay: hasMultipleSlides ? {
        disableOnInteraction: false,
        delay: interval * 1000,
      } : false,
      modules: [Autoplay ,Navigation, Pagination, EffectFade],
      navigation: {
        nextEl: navigationNext.current,
        prevEl: navigationPrev.current,
      },
      pagination: {
        el: sliderPagination.current,
        clickable: true,
      },
    });

    carouselSliderConfig.on('slideChange', () => {
      carouselSliderConfig.pagination.render();
      carouselSliderConfig.pagination.update();
    });
  }, []);

  return (
    <>
      <section className='carousel-slider-section'>
        <div className='carousel-slider-wrapper'>

          {hasMultipleSlides && (
            <button
              className='carousel-slider-next'
              ref={navigationNext}
            >
              <SpriteIcon icon='sliderArrow' />
            </button>
          )}

          <div
            className='swiper carousel-slider'
            ref={carouselImageSlider}
          >
            <ul className='carousel-list swiper-wrapper'>
              {slides && slides.map((slide, index) => {
                return !slide.hidden &&
                <CarouselImageSliderItem
                  key={index}
                  item={slide}
                />;
              })}
            </ul>
          </div>

          {hasMultipleSlides && (
            <button
              className='carousel-slider-prev'
              ref={navigationPrev}
            >
              <SpriteIcon icon='sliderArrow' />
            </button>
          )}

        </div>

        {hasMultipleSlides && (
          <div className='carousel-slider-pagination' ref={sliderPagination} />
        )}
      </section>

    </>
  );
};
